import React from "react"
import Link from "@components/anti/Link"
import { translations } from "src/helper/translations"
import { useScrollAnim } from "src/hooks/hooks"
import { convertHtmlToReact } from "src/mixins"

export default function ContactMaps({ data, locale }) {
  const [trigger, anim] = useScrollAnim()
  return (
    <section className="sc-contact-maps" ref={trigger}>
      <div className="cinema-gradient" />
      <div className="container">
        <div className="row">
          <div className="col-md-7 col-maps">
            {/* <iframe
              title="outlet-maps"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3966.300597595171!2d106.80571671497282!3d-6.224038362690678!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69f1519682bf75%3A0xc26a4848101741d2!2sPT%20Nusantara%20Sejahtera%20Jaya!5e0!3m2!1sid!2sid!4v1675673344857!5m2!1sid!2sid"
              style={{ border: 0 }}
              width
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className={`maps-wrapper ${anim(1)}`}
            /> */}
            {convertHtmlToReact(data?.google_maps_embed_url)}
          </div>
          <div className="col-md-5 col-text">
            <h4 className={`title ${anim(2)}`}>{data?.company_name}</h4>
            <p className={`text mb-0 ${anim(3)}`}>{data?.line_1}</p>
            <p className={`text ${anim(4)}`}>{data?.line_2}</p>
            <Link
              href={data?.google_maps_url}
              target="_blank"
              withArrow
              className={`btn-google ${anim(4)}`}
            >
              {translations[`view_google_maps_${locale}`]}
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}
